module.exports = __webpack_public_path__ + "img/mariage-3-thumbnail.c62b7f5d.jpg";